import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter','Noto Sans JP',sans-serif" }}>
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-4 md:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/27619c500cc1b52bbdf164e0a3e622eb/58ff4382ad3eba0a2a097f9160e1ae7b.png"
              alt="Visipo Logo"
              className="h-7 w-auto object-contain"
            />
            <span className="font-bold text-lg text-gray-900" style={{ fontFamily: "'Inter', sans-serif" }}>Visipo</span>
          </Link>
          <Link
            to="/"
            className="text-sm text-gray-500 hover:text-[#13B6EC] transition-colors flex items-center gap-1"
          >
            <i className="ri-arrow-left-line" />
            トップに戻る
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 md:px-8 py-12 md:py-20">
        {/* Title */}
        <div className="mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold text-[#13B6EC] bg-[#13B6EC]/8 tracking-widest uppercase mb-4">
            TERMS OF SERVICE
          </div>
          <h1
            className="text-2xl sm:text-3xl md:text-4xl font-black text-gray-900 mb-4"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            アプリ利用規約
          </h1>
          <p className="text-sm text-gray-400">施行日: 2026年5月5日</p>
        </div>

        {/* Terms content */}
        <div className="prose-policy">
          <p>
            本利用規約（以下「本規約」といいます。）は、開発者 Nagao.dev（以下「開発者」といいます。）が提供するスマートフォン向けアプリケーション「Visipo」（以下「本アプリ」といいます。）及び本アプリを通じて提供される各種サービス（以下、総称して「本サービス」といいます。）の利用条件を定めるものです。ユーザーの皆様（以下「ユーザー」といいます。）には、本規約に従って本サービスをご利用いただきます。
          </p>

          {/* 第1条 */}
          <h2>第1条（規約への同意）</h2>
          <ol>
            <li>ユーザーは、本規約に同意しない限り、本アプリ及び本サービスを利用することができません。</li>
            <li>ユーザーが情報端末に本アプリをダウンロードし、現実の利用を開始した時点で、ユーザーは本規約に有効かつ取消不能な同意をしたものとみなされます。</li>
            <li>ユーザーが未成年者である場合は、親権者等の法定代理人の同意を得たうえで本サービスを利用するものとします。未成年者が利用を開始した場合、法定代理人の同意があったものとみなします。</li>
          </ol>

          {/* 第2条 */}
          <h2>第2条（利用規約の変更）</h2>
          <ol>
            <li>開発者は、社会情勢の変化、法令の改廃、本サービスの内容変更その他の事情により本規約の変更が必要であると判断した場合、ユーザーの個別の承諾を得ることなく、いつでも本規約を変更できるものとします。</li>
            <li>開発者は、前項の変更を行う場合、事前に、変更後の本規約の内容及び効力発生時期を本アプリ内の通知等、開発者が適当と判断する方法によりユーザーに通知します。ただし、変更が軽微かつユーザーに不利益とならない変更については、事前の予告を省略できるものとします。</li>
            <li>改定後の本規約の効力発生日以降に、ユーザーが本サービスを利用した場合、ユーザーは変更後の本規約の内容に同意したものとみなされます。</li>
          </ol>

          {/* 第3条 */}
          <h2>第3条（連絡方法）</h2>
          <ol>
            <li>本サービスに関する開発者からユーザーへの連絡事項（本規約の変更通知を含みます。）は、本アプリ内の通知、プッシュ通知、その他開発者が適当と判断する方法により行います。</li>
            <li>本サービスに関するユーザーから開発者への連絡またはお問い合わせは、本アプリ内に設置する「お問い合わせフォーム」または開発者が別途指定する方法を通じて行うものとします。</li>
          </ol>

          {/* 第4条 */}
          <h2>第4条（アカウントの管理）</h2>
          <ol>
            <li>ユーザーは、本アプリの利用に際してアカウント情報（ユーザーID、パスワード、連携する他社サービスのアカウント情報等を含みます。）を登録する場合、真実・正確かつ完全な情報を開発者に提供するものとします。</li>
            <li>ユーザーは、自己のアカウント情報を、自己の責任と負担において厳重に管理し、第三者に譲渡、貸与、名義変更、売買等をしてはなりません。</li>
            <li>開発者は、ユーザーのアカウント情報を用いて行われた一切の行為を、当該ユーザー自身の行為とみなし、ユーザーはこれによって生じた結果及び一切の責任（開発者または第三者に対する損害賠償を含みます。）を負担するものとします。</li>
          </ol>

          {/* 第5条 */}
          <h2>第5条（アプリ利用環境の準備と条件）</h2>
          <ol>
            <li>ユーザーは、本アプリの利用にあたり、必要なスマートフォン等の情報端末、OS、通信機器、ヘルスケアデータとの連携設定、通信環境、電力等を、自己の責任と負担において準備し維持するものとします。</li>
            <li>ユーザーは、開発者が定める推奨環境（対応するOSバージョン等）以外の環境では、本アプリの全部または一部の機能を利用できない場合があることを予め了承するものとします。</li>
          </ol>

          {/* 第6条 */}
          <h2>第6条（利用料金及び決済）</h2>
          <ol>
            <li>本サービスには、無料で利用できる範囲（以下「無料トライアル期間」といいます。）と、有料のサブスクリプション契約（以下「有料プラン」といいます。）があります。無料トライアル期間は、本アプリの初回利用開始日から1か月間（30日間）とします。当該期間中は、本アプリのすべての機能を無料でご利用いただけます。</li>
            <li>無料トライアル期間終了後も引き続き本サービスの機能を利用するためには、有料プランへの加入が必要です。有料プランに加入されない場合、無料トライアル期間終了後は本アプリの主要機能の利用が制限されます。</li>
            <li>有料プランには、月額プラン（月額300円（税込）またはこれに相当する現地通貨額）があります。具体的な金額はApp StoreまたはGoogle Playの各ストア画面に表示される価格に従います。有料プランに加入されたユーザーは、すべての機能を引き続きご利用いただけます。</li>
            <li>有料プランの決済は、ユーザーがApp StoreまたはGoogle Playに登録した決済方法を通じて行われます。決済に関する処理はプラットフォーマーの定めるところに従い、開発者はユーザーのクレジットカード情報等を直接取得せず、決済処理に関して一切の責任を負わないものとします。</li>
            <li>有料プランは、ユーザーが解約手続きを完了しない限り、契約期間満了時に自動的に更新されます。解約手続きは、App StoreまたはGoogle Playの各ストアの設定画面から行うものとします。</li>
            <li>開発者は、有料プランの料金を変更する場合、事前にユーザーに通知します。変更後の料金は、次回の更新時から適用されます。</li>
            <li>ユーザーが支払った利用料金は、法令の定めにより返金が義務となる場合を除き、いかなる理由であっても返金しないものとします。</li>
          </ol>

          {/* 第7条 */}
          <h2>第7条（ユーザーコンテンツの取扱い）</h2>
          <ol>
            <li>本アプリにおいてユーザーが記録・作成した日記、コメント、写真、その他のコンテンツ（以下「ユーザーコンテンツ」といいます。）の著作権は、原則としてユーザー自身に留保されます。</li>
            <li>ユーザーは、開発者に対し、本サービスの提供・維持・改善を目的とする範囲において、無償かつ非独占的にユーザーコンテンツを利用（複製、翻案、公衆送信等を含みます。）する権利を許諾するものとし、開発者に対する著作者人格権の行使を行わないものとします。</li>
            <li>開発者は、ユーザーコンテンツが本規約に違反する、または法令等に違反するおそれがあると開発者が判断した場合、事前の通知なく、当該ユーザーコンテンツの全部または一部を削除・非表示にする等の措置を講じることができるものとします。ただし、開発者はすべてのユーザーコンテンツを監視する義務を負うものではありません。</li>
          </ol>

          {/* 第8条 */}
          <h2>第8条（禁止事項）</h2>
          <p>ユーザーは、本サービスの利用にあたり、以下の各号のいずれかに該当する行為、または該当するおそれのある行為をしてはなりません。</p>
          <ol>
            <li>本規約または法令、公序良俗に違反する行為</li>
            <li>開発者または第三者の知的財産権、肖像権、プライバシー、名誉その他の権利を侵害する行為</li>
            <li>スマートフォンの歩数データを偽装・不正改ざんする行為、またはこれらを助長するツール類等を利用する行為（チート行為）</li>
            <li>わいせつ、暴力的、差別的、その他第三者に不快感を与える内容のユーザーコンテンツを作成する行為</li>
            <li>本サービスのネットワークまたはシステム等に過度な負荷をかける行為、リバースエンジニアリング、逆コンパイル等の解析行為</li>
            <li>その他、開発者が不適切と合理的に判断する行為</li>
          </ol>

          {/* 第9条 */}
          <h2>第9条（個人情報の取扱い）</h2>
          <ol>
            <li>開発者は、本サービスの提供にあたり、ユーザーの個人情報（歩数等のヘルスケアデータ、端末情報、利用履歴等を含みます。）を取得する場合があります。</li>
            <li>取得した個人情報の取扱いについては、開発者が別途定める<Link to="/privacy" className="text-[#13B6EC] hover:underline">プライバシーポリシー</Link>に従うものとし、ユーザーは当該プライバシーポリシーに同意したうえで本サービスを利用するものとします。</li>
            <li>開発者は、法令に基づく場合を除き、ユーザーの同意なく個人情報を第三者に提供しません。</li>
          </ol>

          {/* 第10条 */}
          <h2>第10条（サービスの中断・終了）</h2>
          <ol>
            <li>
              開発者は、以下のいずれかに該当する場合、ユーザーに事前に通知したうえで、本サービスの全部または一部を中断または終了することができるものとします。ただし、緊急性が高い場合は事前の通知を省略できるものとします。
              <ul className="mt-2">
                <li>本サービスに関するシステムの保守・点検・更新を行う場合</li>
                <li>天災地変、停電、通信障害その他やむを得ない事由が生じた場合</li>
                <li>外部サービス（第11条第2項に定めるものを含みます。）の提供が中断または終了した場合</li>
                <li>その他、開発者が本サービスの中断または終了が必要と合理的に判断した場合</li>
              </ul>
            </li>
            <li>開発者が本サービスを終了する場合、合理的な期間をもって事前にユーザーに通知するよう努めるものとします。</li>
            <li>開発者は、本サービスの中断または終了によりユーザーに生じた損害について、一切の責任を負わないものとします。</li>
          </ol>

          {/* 第11条 */}
          <h2>第11条（非保証及び免責条項）</h2>
          <ol>
            <li>開発者は、本サービス（歩数データの取得、ルートの再現性、天候情報等を含みます。）について、その正確性、完全性、有用性、特定の目的への適合性、バグ等の不具合がないこと、第三者の権利を侵害していないことについて、明示的にも黙示的にも一切の保証を行いません。</li>
            <li>本アプリは、Apple Inc.の「ヘルスケア」やGoogle LLCの「Google Fit」等の外部サービス（以下「外部サービス」といいます。）と連携して歩数等のデータを取得しますが、外部サービスの仕様変更や不具合により本アプリが正常に動作しなくなった場合でも、開発者は一切の責任を負わないものとします。</li>
            <li>開発者は、本サービスを利用したこと、または利用できなかったことに起因してユーザーに生じたあらゆる損害について、一切の責任を負いません。ただし、消費者契約法その他の強行法規の適用により開発者が損害賠償責任を免れない場合、その賠償責任は、現実に発生した直接かつ通常の損害に限られ、いかなる場合でも、ユーザーが損害発生日から遡って過去12ヶ月間に本サービスに対して支払った利用料金の総額（無償利用の場合は1,000円）を上限とします。</li>
          </ol>

          {/* 第12条 */}
          <h2>第12条（プラットフォーマーの免責）</h2>
          <ol>
            <li>ユーザーは、Apple Inc.（App Store）またはGoogle LLC（Google Play）等のプラットフォーマー（以下総称して「プラットフォーマー」といいます。）が定めた利用規約等を遵守するものとします。</li>
            <li>本規約は、開発者とユーザー間のものであり、プラットフォーマーは本サービスおよび本アプリの提供に関して一切の責任を負わないものとします。ユーザーから本アプリに関する申告、クレーム、および法的措置があった場合、その対応と解決は開発者が行い、プラットフォーマーは免責されます。</li>
          </ol>

          {/* 第13条 */}
          <h2>第13条（権利義務の譲渡禁止等）</h2>
          <ol>
            <li>ユーザーは、開発者の書面等による事前の承諾なく、本規約上の地位または本規約に基づく権利義務の全部または一部を、第三者に譲渡、販売、貸与、担保提供その他の処分をすることはできません。</li>
            <li>開発者が、本サービスに関する事業を他社等に譲渡した場合、開発者は当該事業譲渡に伴い、本規約上の地位、本規約に基づく権利義務、ユーザーのアカウント情報及びその他の情報を、当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーはあらかじめこれに同意するものとします。</li>
          </ol>

          {/* 第14条 */}
          <h2>第14条（分離可能性）</h2>
          <p>
            本規約のいずれかの条項またはその一部が、消費者契約法その他の法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定は、引き続き完全に有効なものとして存続するものとします。
          </p>

          {/* 第15条 */}
          <h2>第15条（準拠法及び管轄裁判所）</h2>
          <ol>
            <li>本規約の成立、効力、解釈及び履行については、日本法を準拠法とします。</li>
            <li>本規約が日本語以外の言語でも提供され、日本語版と翻訳版との間に矛盾や相違がある場合、全ての点において日本語版が優先されるものとします。</li>
            <li>本サービスまたは本規約に関してユーザーと開発者との間に紛争が生じた場合、横浜地方裁判所または横浜簡易裁判所を第一審の専属的合意管轄裁判所とします。</li>
          </ol>

          <div className="mt-10 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              <strong>附則</strong><br />
              本規約は、2026年5月5日より施行します。（2026年5月5日改定：無料トライアル期間を1週間から1か月間（30日間）に変更）
            </p>
          </div>
        </div>

        {/* Back button */}
        <div className="mt-16 pt-8 border-t border-gray-100 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[#13B6EC] text-sm font-semibold hover:underline"
          >
            <i className="ri-arrow-left-line" />
            トップページに戻る
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center" style={{ background: "#1a2332" }}>
        <p className="text-xs" style={{ color: "rgba(255,255,255,0.3)" }}>
          &copy; 2026 Visipo. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
